import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import * as Bootstrap from 'bootstrap'
import i18n from './i18n'
//import { BootstrapVue } from 'bootstrap-vue'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/styles/typography.css'


const app = createApp(App)

app.use(router)
app.use(Bootstrap)
//app.use(BootstrapVue)
app.use(i18n)
app.mount('#app')
